import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import  Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import kavidaLogo from "../../assets/images/kavida_logo.webp";
import { trackUserJourney } from "../../services/api.service";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import formBackgroundImg from "../../assets/images/formBackgroundImg.webp";

const StartTourRegistrationForm = () => {
  const history = useHistory();
  const userContext = useContext(userJourneyContext);
  const [userName, setUserName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [jobTitle, setJobTitle] = React.useState("");
  const [userNameErrorText, setUserNameErrorText] = React.useState("");
  const [jobTitleErrorText, setJobTitleErrorText] = React.useState("");
  const [emailErrorText, setEmailErrorText] = React.useState("");
  const blockEmails = [
    "gmail.com",
    "outlook.com",
    "yahoo.com"
  ]
  const classes = useStyles();

  const isValidEmail = (email) => {
    const checkEmail = email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if(checkEmail && !blockEmails.includes(checkEmail[5])){
      return true 
    }else{
      return false
    }
  };

  const handleClick = () => {
    if (userName.length > 0 && isValidEmail(email) && jobTitle.length > 0) {
      history.push(`/kavida/tour`);
      (async () => {
        try {
          const userData = {...userContext.userJourneyInfo};
          userData.payload.send_auto_email_id = 2
          let payload = {
            ...userData,
            name: userName,
            email: email,
            role: "Merchandiser",
          };
          const _userJourney = userContext.userJourneyInfo;
          _userJourney.name = userName;
          _userJourney.email = email;
          _userJourney.role = "Merchandiser";
          userContext.setUserJourneyInfo(_userJourney);
          await trackUserJourney(payload);
        } catch (e) {
          console.log(e);
        }
      })();
    }
    if (userName.length === 0) {
      setUserNameErrorText("Please enter a name");
    }
    if (!isValidEmail(email)) {
      setEmailErrorText("Please use your company email address");
    }
    if (jobTitle.length === 0) {
      setJobTitleErrorText("Please enter a job title")
    }
  };

  return (
    <div style={{backgroundImage: `url(${formBackgroundImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
      <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Paper elevation={24} className={classes.root}>
        <Grid container className={classes.containerStyle}>
          <Grid container>
            <Grid item xs={12}>
              <img
                src={kavidaLogo}
                style={{
                  width: "138px",
                  height: "52px",
                  marginLeft: "112px",
                }}
                alt={"KAVIDA"}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                className={classes.titleStyle}
                align="center"
              >
                Fulfilment Management System
              </Typography>
              <Typography className={classes.subTitleStyle} align="center">
                Take the tour to find out more.
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.formContainerStyle}>
            <Grid container className={classes.inputContainerStyle}>
              <Grid item xs={12}>
                <Typography className={classes.labelStyle}>Name</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    className: classes.inputTextStyle,
                  }}
                  InputProps={{
                    classes: {
                      notchedOutline: classes.outlineStyle,
                    },
                  }}
                  error={userNameErrorText}
                  helperText={userNameErrorText}
                  fullWidth
                  placeholder="First Name, Last Name"
                  onChange={(event) => {
                    setUserName(event.target.value);
                    setUserNameErrorText("");
                  }}
                />
              </Grid>
            </Grid>
            <Grid container className={classes.inputContainerStyle}>
              <Grid item xs={12}>
                <Typography className={classes.labelStyle}>Email</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  type={"email"}
                  placeholder="name@company.com"
                  className={classes.textFieldStyle}
                  inputProps={{
                    className: classes.inputTextStyle,
                  }}
                  InputProps={{
                    classes: {
                      notchedOutline: classes.outlineStyle,
                    },
                  }}
                  fullWidth
                  error={emailErrorText}
                  helperText={emailErrorText}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setEmailErrorText("");
                  }}
                />
              </Grid>
            </Grid>
            <Grid container className={classes.inputContainerStyle}>
              <Grid item xs={12}>
                <Typography className={classes.labelStyle}>Job Title</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  placeholder="Merchandiser"
                  className={classes.textFieldStyle}
                  inputProps={{
                    className: classes.inputTextStyle,
                  }}
                  InputProps={{
                    classes: {
                      notchedOutline: classes.outlineStyle,
                    },
                  }}
                  error={jobTitleErrorText}
                  helperText={jobTitleErrorText}
                  fullWidth
                  onChange={(event) => {
                    setJobTitle(event.target.value);
                    setUserNameErrorText("");
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                className={classes.buttonStyle}
                classes={{
                  contained: classes.buttonTextStyle,
                }}
                onClick={() => handleClick()}
              >
                Start Tour
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
    </div>
  );
};

export default StartTourRegistrationForm;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "40px",
    width: "356px",
    height: "520px",
    borderRadius: "8px",
    top: "173px",
    left: "523px",
  },
  labelStyle: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#64748B",
    lineHeight: "16px",
  },
  containerStyle: {
    margin: "10px 0px",
  },
  titleStyle: {
    marginLeft: "40px",
    marginRight: "40px",
    marginTop: "24px",
    fontSize: "18px",
    fontWeight: 700,
    textAlign: "center",
  },
  subTitleStyle: {
    marginLeft: "40px",
    marginRight: "40px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#64748B",
    textAlign: "center",
    lineHeight: "20px",
  },
  formContainerStyle: {
    margin: "24px 0px",
  },
  textFieldStyle: {
    margin: "8px 0px",
    borderRadius: "2px",
  },
  inputContainerStyle: {
    marginBottom: "16px",
  },
  buttonStyle: {
    padding: "8px 16px",
    borderRadius: "2px",
    background: "#3B82F6",
    fontSize: "20px",
    fontWeight: 400,
    textAlign: "center",
    color: "#FFFFFF",
    textTransform: "none",
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "#3B82F6",
    },
  },
  inputTextStyle: {
    padding: "10px",
    fontWeight: 400,
  },
  buttonTextStyle: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
  },
  outlineStyle: {
    borderColor: "#E2E8F0 !important",
  },
}));
